import IMG_POLICY from 'assets/images/clients/reminders/Cancellation-policy.jpg';
import IMG_CONSULTATION from 'assets/images/clients/reminders/Consultation-form.jpg';
import IMG_CUSTOM from 'assets/images/clients/reminders/Custom.jpg';
import IMG_PARKING from 'assets/images/clients/reminders/Parking-information.jpg';
import SMS_TEMPLATE_NAME from 'constants/salon/smsTemplateName.const';
import C from 'utils/values/constant.util';

const SMS_TEMPLATE = C({
  [SMS_TEMPLATE_NAME.policy]: {
    id: SMS_TEMPLATE_NAME.policy,
    descriptionTransKey: 'reminders.smsTemplates.cancellationPolicy',
    imgSrc: IMG_POLICY,
  },
  [SMS_TEMPLATE_NAME.parking]: {
    id: SMS_TEMPLATE_NAME.parking,
    descriptionTransKey: 'reminders.smsTemplates.parkingInfo',
    imgSrc: IMG_PARKING,
  },
  [SMS_TEMPLATE_NAME.consultation]: {
    id: SMS_TEMPLATE_NAME.consultation,
    descriptionTransKey: 'reminders.smsTemplates.consultationForm',
    imgSrc: IMG_CONSULTATION,
  },
  [SMS_TEMPLATE_NAME.custom]: {
    id: SMS_TEMPLATE_NAME.custom,
    descriptionTransKey: 'reminders.smsTemplates.custom',
    imgSrc: IMG_CUSTOM,
  },
});

export default SMS_TEMPLATE;
